<template>
  <PaginationContainer v-bind="$attrs" v-on="$listeners"></PaginationContainer>
</template>

<script>
import PaginationContainer from "@/own/components/pagination/paginationNew/PaginationContainerNew.vue";
export default {
  name: "Pagination",
  components: { PaginationContainer },
};
</script>
